export interface ResultatPreadmissibiliteModel {
  statut: StatutPreadmissibilite;
  numeroDemande: string;
  id?: string;
}

export enum StatutPreadmissibilite {
  Refuser = 'REFUSEE',
  AdmisPreautorisation = 'ADMIS_PREAUTORISATION'
}
